// src/components/Login.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { msalInstance } from "../msalInstance";
import { loginRequest } from "../msalConfig";
import logo from "../assets/filepigeon_logo.png";
import { useDemoView } from "../theme/demoView";

export default function Login() {
  // We only need the account from auth context now (no popup login)
  const { account } = useAuth();
  const navigate = useNavigate();
  const lbView = useDemoView();

  useEffect(() => {
    if (account) {
      console.log("✅ Already logged in as", account.username);
      // Use replace so /login isn't left in history
      navigate("/home", { replace: true });
    }
  }, [account, navigate]);

  const handleLoginClick = () => {
    console.log("👉 Login button clicked (redirect flow)");
    // Use redirect-based login to avoid popup + COOP issues
    msalInstance.loginRedirect(loginRequest);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom right, var(--theme-tint-15), #ffffff)",
        fontFamily: "Segoe UI, Arial, sans-serif",
      }}
    >
      <div
        style={{
          padding: "40px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {!lbView && (
          <img
            src={logo}
            alt="FilePigeon"
            style={{
              width: 80,
              height: 80,
              objectFit: "contain",
              margin: "0 auto 20px",
              display: "block",
            }}
          />
        )}

        <h2 style={{ marginBottom: "10px", color: "var(--theme-ink)" }}>
          {lbView ? "Welcome to the FDD Toolbox" : "Welcome to FilePigeon"}
        </h2>
        <p style={{ fontSize: "14px", color: "#555", marginBottom: "30px" }}>
          Sign in with your Microsoft account to access your dashboard.
        </p>

        <button
          onClick={handleLoginClick}
          style={{
            backgroundColor: "var(--theme-accent)",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "6px",
            fontSize: "14px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.currentTarget.style.backgroundColor = "var(--theme-accent-hover)";
          }}
          onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.currentTarget.style.backgroundColor = "var(--theme-accent)";
          }}
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
